export const StatusApontamento = [
  {
    id: 'A',
    label: 'Atendido',
    cor: '#5A7D7C', // Verde escuro (Em atendimento)
  },
  {
    id: 'S',
    label: 'Confirmado',
    cor: '#A1C5E5', // Azul claro (Confirmado)
  },
  {
    id: 'N',
    label: 'Não Confirmado',
    cor: '#F5B3B0', // Salmão (Não Confirmado)
  },
  {
    id: 'I',
    label: 'Falta',
    cor: '#D26A4A', // Vermelho escuro (Falta)
  },
  {
    id: 'O',
    label: 'Encaixe',
    cor: '#BCE29D', // Verde limão (Encaixe)
  },
];
